import { Dialog, DialogContent, DialogTitle, Grid } from '@mui/material'
import { TitleText } from '../../../component/layout/layoutMainStyle'
import InputTextField from '../../../component/input/inputTextField'
import ButtonCustom from '../../../component/button/buttonCustom'
import ClearIcon from '@mui/icons-material/Clear';

type PropsDialogCreate = {
    openCreate: boolean
    handleCloseCreate: any
    value: any
    setInput: any
    clearErrorMessage?: any
    errorMessage?: any
    submit?: any
    loading?: boolean,
    stepView?: number
}

export function DialogCreate(props: PropsDialogCreate) {
    const {
        openCreate,
        handleCloseCreate,
        value,
        setInput,
        errorMessage,
        clearErrorMessage,
        submit,
        loading,
        stepView
    } = props

    return (
        <Dialog
            open={openCreate}
            keepMounted
            onClose={handleCloseCreate}
            fullWidth
            maxWidth='md'
        >
            <DialogTitle sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                <ClearIcon sx={{ cursor: 'pointer', fontSize: "20px" }} onClick={() => handleCloseCreate()} />
            </DialogTitle>
            <DialogContent sx={{ padding: '32px', gap: '32px', display: 'flex', flexDirection: "column" }}>
                <div style={{ display: "flex", justifyContent: 'center', width: '100%' }}>
                    <TitleText>
                        สร้าง
                    </TitleText>
                </div>

                <Grid container spacing={1}>

                    <Grid item xs={12} sx={{ marginBottom: '20px' }}>
                        <InputTextField required heading={`ชื่อ${stepView === 1 ? 'ตู้' : stepView === 2 ? 'ชั้น' : stepView === 3 ? 'แฟ้ม' : stepView === 4 ? 'ประเภท' : ''}เอกสาร`}
                            value={value.folderName}
                            onchange={(e) => {
                                setInput({ ...value, folderName: e.target.value })
                                clearErrorMessage();
                            }}
                            helperText={
                                errorMessage.FOLDERNAME || ''
                            } />
                    </Grid>
                    {!value.idReferFolder && <Grid item xs={12}>
                        <InputTextField
                            heading='สถานที่จัดเก็บ*'
                            value={value.folderLocation}
                            onchange={(e) => {
                                setInput({ ...value, folderLocation: e.target.value })
                            }} /></Grid>}
                </Grid>
                <ButtonCustom textButton={'บันทึก'} style={{ margin: "auto" }} disabled={loading} onClick={submit} />
            </DialogContent>

        </Dialog>
    )
}
